import { LogoBlack, LogoWhite } from "../assets/images";

export default function Logo({ white = false, style = {} }) {
  return (
    <img
      src={white ? LogoWhite : LogoBlack}
      alt="Logo"
      style={{ cursor: "pointer", width: "200px", maxHeight: 50, objectFit: "contain", ...style }}
    />
  );
}
